import { CheckoutContext } from '@/context/CheckoutContext';
import { useCallback, useContext, useEffect, useRef } from 'react';
import { StripePaymentIntentStatus } from '@/types/payment';
import { ProviderEnum } from '@/types/common';
import { useTranslate } from '@/hooks/useTranslate';
import { notifyPaymentIntentFailed, notifyPaymentIntentSuccess } from '@/utils/notifier';
import { getEventDataForSdkEvents } from '@/utils/eventDataBuilder';
import { useCheckoutData } from '@/api/useCheckoutData';

export const CashAppRedirect = () => {
  const isInProcessing = useRef(false);
  const context = useContext(CheckoutContext);
  const checkoutData = useCheckoutData({ enableFetch: false });
  const {
    stripe,
    redirectPayment,
    actions: { setError, startOrderPolling, setSuccessScreen, setIsInPaymentProcess, setRedirectPayment },
  } = context;
  const { clientSecret } = redirectPayment;
  const { t } = useTranslate();
  const handleCashAppNextAction = useCallback(async () => {
    if (isInProcessing.current) return;
    isInProcessing.current = true;

    try {
      const paymentIntentResult = await stripe?.handleNextAction({ clientSecret: clientSecret || '' });
      const paymentIntentStatus = paymentIntentResult?.paymentIntent?.status;

      if (
        paymentIntentResult?.error ||
        paymentIntentStatus === StripePaymentIntentStatus.REQUIRES_PAYMENT_METHOD ||
        paymentIntentStatus === StripePaymentIntentStatus.REQUIRES_ACTION
      ) {
        setError(t('somethingWentWrong'));
        notifyPaymentIntentFailed(checkoutData.data!);
        setIsInPaymentProcess(false);
        setRedirectPayment({});
        isInProcessing.current = false;
      }
      if (paymentIntentStatus === StripePaymentIntentStatus.SUCCEEDED) {
        startOrderPolling(redirectPayment.orderId || '');
        notifyPaymentIntentSuccess(getEventDataForSdkEvents(checkoutData.data!));
        setSuccessScreen({
          isOpen: true,
          paymentDetails: { params: paymentIntentResult?.paymentIntent },
          provider: ProviderEnum.STRIPE,
        });
      }
    } catch (error) {
      setError(t('somethingWentWrong'));
      setIsInPaymentProcess(false);
      setRedirectPayment({});
      isInProcessing.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientSecret]);

  useEffect(() => {
    handleCashAppNextAction();
  }, [handleCashAppNextAction]);

  return null;
};
